import React from 'react'
import { Button, Dialog, DialogTitle, DialogContent, DialogActions, Typography } from '@material-ui/core'
import PropTypes from 'prop-types'

// TODO: could probably be extracted as general purpose dialog
export default function TitheDialog({ open, handleClose, handleComplete, title, firstLine, secondLine, formattedAmount }) {

  return (
    <Dialog open={open} onClose={handleClose}>
      <DialogTitle>{title}</DialogTitle>
      <DialogContent>
        <Typography variant='body1'>
          {firstLine}
        </Typography>
        <Typography variant='subtitle2' align='center'>
          {secondLine}
        </Typography>
        <Typography align='center' variant='h6' color='secondary'>
          {formattedAmount}
        </Typography>
      </DialogContent>
      <DialogActions>
        <Button variant='text' onClick={handleClose} color='secondary'>cancel</Button>
        <Button variant='contained' color='secondary' onClick={handleComplete}>ok</Button>
      </DialogActions>
    </Dialog>
  )
}

TitheDialog.propTypes = {
  open: PropTypes.bool.isRequired,
  handleClose: PropTypes.func.isRequired,
  handleComplete: PropTypes.func,
  title: PropTypes.string,
  firstLine: PropTypes.string,
  secondLine: PropTypes.string,
  formattedAmount: PropTypes.string,
}
